import React from 'react';

const DebtCollection = () => {
    return (
        <div style={{ padding: '40px 15px' }}>
            <h3>Nội dung về Dịch vụ Thu hồi nợ</h3>
            <p>Chi tiết về lĩnh vực Thu hồi nợ sẽ được trình bày ở đây...</p>
        </div>
    );
};

export default DebtCollection;